module.exports = __webpack_public_path__ + "static/media/Lato-Bold.fbb2d7a4.woff2";